import { render, staticRenderFns } from "./CallToActionBlocks.vue?vue&type=template&id=590901e5&scoped=true"
import script from "./CallToActionBlocks.vue?vue&type=script&lang=js"
export * from "./CallToActionBlocks.vue?vue&type=script&lang=js"
import style0 from "./CallToActionBlocks.vue?vue&type=style&index=0&id=590901e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590901e5",
  null
  
)

export default component.exports